import React from 'react'
import ProfileInfo from 'src/app/ProfileInfo/ProfileInfo'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { profileInfoRouteProps } from 'src/navigation/routeProps'

const ProfileInfoAppRoute: AppRoute = {
  id: AppLocation.ProfileInfo,
  routeProps: profileInfoRouteProps,
  component: <ProfileInfo />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ProfileInfoAppRoute
